import { IconButton} from "@material-ui/core";
import React from "react"
import AddCommentIcon from '@material-ui/icons/AddComment'
import { AddFactoryCommentForm } from "../components/panel/factoryCaseForm/AddFactoryCommentForm";
import { useDispatch, useSelector } from "react-redux";
import { setTableActiveCommentForm } from "../redux/factoryCases/factoryCasesSlice";
import { selectActiveCommentFormId } from "../redux/factoryCases/selectors";
import { Popover } from 'devextreme-react/popover';

function FactoryMenuTable(props){

    const {data, id} = props;
    const dispatch = useDispatch();
    const selectedCommentForm = useSelector(selectActiveCommentFormId)
    const isVisible = selectedCommentForm === id
    const disabled = data.data.state.toLowerCase() === "encerrado"

    function handleShowForms(){
        if(selectedCommentForm === id)
         {
            dispatch(setTableActiveCommentForm(null))          
        }
        else{
            dispatch(setTableActiveCommentForm(id))
        }
    }

    function handleClick(e){
        handleShowForms();
    }

    return(
        <div id={`button-${id}`}>
            <IconButton onClick={(e)=>{handleClick(e)}} disabled={disabled} size="small"><AddCommentIcon/></IconButton>
            <Popover 
                contentRender={()=> <AddFactoryCommentForm 
                                        formClassName={"comment-form-table"} 
                                        processId={data.data.processId} 
                                        expedient={data.data.currentExpedient || data.data.expedient} 
                                        showAddFactoryCommentForm={true } 
                                        handleShowForms={handleShowForms}
                                        showConfirm={true}
                                        setShowAddFactoryCommentForm={()=>dispatch(setTableActiveCommentForm(null))}
                                        />} 
                target={`#button-${id}`} 
                position={"left"}
                onHiding={()=>dispatch(setTableActiveCommentForm(null))}
                onShowing={()=>dispatch(setTableActiveCommentForm(id))}
                closeOnOutsideClick
                visible={isVisible}>
            </Popover>
        </div>
    )
}

export {FactoryMenuTable}

